module.exports = "/images/ny-life1-2.jpg";